<template>
    <div id="new-trendyol-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>Kanal Adı</label>
                    <a-form-item>
                        <a-input v-model="form.channelName" placeholder="Kanal Adı" />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>Trendyol Satıcı ID</label>
                    <a-input v-model="form.sellerId" placeholder="Trendyol Satıcı ID" />
                </div>
                <div class="input-wrapper">
                    <label>Trendyol API Key</label>
                    <a-input v-model="form.apiKey" placeholder="Trendyol API Key" />
                </div>
                <div class="input-wrapper">
                    <label>Trendyol API Secret Key</label>
                    <a-input v-model="form.apiSecretKey" placeholder="Trendyol API Secret Key" />
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">İptal</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading"
                    >Kaydet
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "NewTrendyolChannel",
    data() {
        return {
            form: {
                channelName: "",
                sellerId: "",
                apiKey: "",
                apiSecretKey: "",
            },
            loading: false,
        };
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            const payload = {
                type: "trendyol",
                name: this.form.channelName,
                payload: {
                    sellerId: this.form.sellerId,
                    apiKey: this.form.apiKey,
                    apiSecretKey: this.form.apiSecretKey,
                },
                commentForward: {
                    mode: "ticket",
                    story: null,
                },
            };
            this.loading = true;
            this.createChannel(payload)
                .then(() => {
                    this.$message.success("Kanal başarıyla oluşturuldu");
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error("Kanal oluşturma başarısız oldu");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
